import { render, staticRenderFns } from "./global_search.vue?vue&type=template&id=b93028c6&scoped=true"
import script from "./global_search.vue?vue&type=script&lang=js"
export * from "./global_search.vue?vue&type=script&lang=js"
import style0 from "./global_search.vue?vue&type=style&index=0&id=b93028c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93028c6",
  null
  
)

export default component.exports